import Marquee from "react-fast-marquee";

const items = [
  "Groceries",
  "Food",
  "Cosmetics",
  "Electronics",
  "Gifts",
  "Flowers",
  "Cakes",
  "Pharmacy",
  "Local Delivery",
  "Chocolates",
  "Hampers",
];

export const EditorialMarquee = () => {
  return (
    <section
      className="relative bg-[#0033FF] py-6 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((it, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-extrabold text-white/95 text-3xl md:text-4xl tracking-tight px-8">
              {it}
            </span>
            <span className="text-white/40 text-2xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
